import { InputSelectCombobox } from "./InputSelectCombobox"
import { NativeSelect } from "./NativeSelect"

export const LIMITE_SEM_BUSCA = 10

const semAcento = (texto: string) => texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "")

export type OpcaoDaEscolha = { valor: string; rotulo: string; detalhe?: string }

type Props = {
  id?: string
  name?: string
  valor: string
  aoMudar: (valor: string) => void
  opcoes: OpcaoDaEscolha[]
  vazio?: string
  obrigatorio?: boolean
  desabilitado?: boolean
  rotulo?: string
  placeholderDaBusca?: string
  classeDaCaixa?: string
}

export function Escolha({
  id,
  name,
  valor,
  aoMudar,
  opcoes,
  vazio,
  obrigatorio = false,
  desabilitado = false,
  rotulo,
  placeholderDaBusca,
  classeDaCaixa,
}: Props) {
  if (opcoes.length <= LIMITE_SEM_BUSCA) {
    return (
      <NativeSelect
        id={id}
        name={name}
        classNameDaCaixa={classeDaCaixa}
        aria-label={rotulo}
        aria-required={obrigatorio ? "true" : undefined}
        required={obrigatorio}
        disabled={desabilitado}
        value={valor}
        onChange={(evento) => aoMudar(evento.target.value)}
      >
        {vazio !== undefined && <option value="">{vazio}</option>}
        {opcoes.map((opcao) => (
          <option key={opcao.valor} value={opcao.valor}>
            {opcao.rotulo}
          </option>
        ))}
      </NativeSelect>
    )
  }
  return (
    <InputSelectCombobox
      id={id}
      aria-label={rotulo}
      required={obrigatorio}
      disabled={desabilitado}
      className={classeDaCaixa}
      options={opcoes.map((opcao) => ({
        value: opcao.valor,
        label: opcao.rotulo,
        subLabel: opcao.detalhe,
        busca: semAcento(`${opcao.rotulo} ${opcao.detalhe ?? ""}`),
      }))}
      value={valor === "" ? null : valor}
      onChange={(escolhido) => {
        if (escolhido === null) {
          if (vazio !== undefined) aoMudar("")
          return
        }
        aoMudar(String(escolhido))
      }}
      placeholder={vazio ?? "Escolha"}
      placeholderDaBusca={placeholderDaBusca ?? "Buscar..."}
    />
  )
}
